define('calendarPendingView',[
  'app',
  'module',
  'underscore',
  'jquery',
  'moment',
  'marionette',
  'bootbox',
  'template!calendarPendingView'
], function (
  App,
  Module,
  _,
  $,
  moment,
  Marionette,
  bootbox,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'calendar-pending-view',

    ui: {
      rows: '.js-rows'
    },

    events: {
      'click .js-approve': 'onApprove',
      'click .js-reject': 'onReject'
    },

    initialize: function () {
      this.pending = [];
    },

    serializeData: function () {
      return {
        pending: _.map(this.pending, function (p) {
          return {
            secId: p.secId,
            title: p.title,
            ownerName: p.ownerName || '',
            start: p.start ? moment(p.start).format('DD/MM/YYYY HH:mm') : '',
            end: p.end ? moment(p.end).format('DD/MM/YYYY HH:mm') : ''
          };
        })
      };
    },

    onShow: function () {
      this.reload();
    },

    reload: function () {
      App.request('calendar:pending').done(_.bind(function (list) {
        this.pending = list || [];
        this.render();
      }, this));
    },

    onApprove: function (e) {
      var secId = $(e.currentTarget).data('secid');
      App.request('calendar:approve', secId)
        .done(_.bind(this.afterChange, this))
        .fail(function () {
          bootbox.alert(_.i18n('calendar.error.approveFailed', null, 'Could not approve the request.'));
        });
    },

    onReject: function (e) {
      var secId = $(e.currentTarget).data('secid');
      bootbox.prompt(_.i18n('calendar.reject.reason', null, 'Reason for rejection (optional):'),
        _.bind(function (reason) {
          if (reason === null) {
            return;
          }
          App.request('calendar:reject', secId, reason)
            .done(_.bind(this.afterChange, this))
            .fail(function () {
              bootbox.alert(_.i18n('calendar.error.rejectFailed', null, 'Could not reject the request.'));
            });
        }, this));
    },

    afterChange: function () {
      if (this.options.onChanged) {
        this.options.onChanged();
      }
      this.reload();
    },

    // Static
    open: function (data) {
      require(['windows', 'calendarPendingView'], function (Windows, View) {
        Windows.open({
          view: function () {
            return new View(data || {});
          },
          title: _.i18n('calendar.pendingApprovals', null, 'Pending approvals'),
          modal: true,
          width: 700,
          maxWidth: 900
        });
      });
    }
  });
});

